// *** Services
import { SengridActions, SessionActions } from "services";
//REACT
import React, {
  useCallback,
  useContext,
  useLayoutEffect,
  useState,
} from "react";
import { Link, useHistory } from "react-router-dom";
import jwt from "jwt-decode";
// @material-ui/icons
import DescriptionIcon from "@material-ui/icons/Description";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import AssignmentIcon from "@material-ui/icons/Assignment";
//Secciones
import Cabecera from "../CabeceraPie/Cabecera";
import PiePagina from "../CabeceraPie/PiePagina";
import NavPills from "components/NavPills/NavPills";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
// *** Contexto
import { UsuarioContext } from "config/context/UsuarioProvider";

//**** Material-UI
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TableStyles from "assets/jss/material-kit-pro-react/components/tableStyle.js";

import CertificatesRevocationForm from "./RevocacionCertificados/CertificatesRevocationForm";
import CertificatesQueryForm from "./ConsultaCertificados/CertificatesQueryForm";

const useStyles = makeStyles(TableStyles);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function IndexHome() {
  // const history = useHistory();
  const history = useHistory();

  const { usuario, setusuario } = useContext(UsuarioContext);
  const classes = useStyles();
  // const tableHead = [
  //   "Producto",
  //   "Estado Certificado",
  //   "Fecha Alta",
  //   "Fecha Caducidad",
  //   "Nº Serie",
  // ];
  const [dataTable, setdataTable] = useState([]);
  const [open, setOpen] = useState(0);

  const [alertisFormValid, setAlertisFormValid] = useState(true);
  const [severity, setSeverity] = useState("error"); // 'success' or 'error'
  const [snackbarMessage, setSnackbarMessage] = useState(
    "Existen campos obligatorio sin completar"
  );

  /*React.useEffect(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      window.localStorage.clear()
      window.sessionStorage.clear()
    })*/
  var formRef = React.createRef();
  var userToken = "";

  const [certQueryStep, setCertQueryStep] = useState(1); // Datos Personales
  const incrementCertQueryStep = useCallback(
    () => setCertQueryStep((prevState) => prevState + 1),
    [setCertQueryStep]
  );

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      flujo();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  function flujo() {
    if (localStorage.getItem("currentUser") === null) {
      localStorage.clear();
      setusuario({ ...usuario, paso: "SELEC_PLAN" });
    } else {
      userToken = jwt(localStorage.getItem("currentUser").replace('"', "")); // decode your token here
      setusuario({
        ...usuario,
        nombres: "",
        apellidos: "",
        rut: "",
        email: "",
        paso: "SELEC_PLAN",
        token: userToken.nameid,
        pin: "",
      });
      cargaInicial();
    }
  }

  function cargaInicial() {
    userToken = jwt(localStorage.getItem("currentUser").replace('"', "")); // decode your token here
    //obtener token desde jwt
    //si el token tiene id_solicitud y no existe el usuario en el storage entonces redireccionar al /
    SessionActions.ValidaToken(userToken.nameid).then((responseToken) => {
      if (
        responseToken.data === true &&
        localStorage.getItem("currentUser") !== null
      ) {
        //preguntar al back en que etapa quedo y asignar a paso (si apreta f5)
        SessionActions.traerEtapa(userToken.nameid).then((response) => {
          const { success, payload } = response.data;
          if (!success) {
            localStorage.clear();
            SessionActions.logout();
            //history.push("/");
          } else {
            setusuario({
              ...usuario,
              token: userToken.nameid,
              paso: payload.codigo,
            });
            if (payload.numero > 1) validaCliente();
          }
        });
      } else if (responseToken.data === true) {
        SessionActions.traerEtapa(userToken.nameid).then((response) => {
          const { payload } = response.data;
          if (payload.numero !== 1) {
            localStorage.clear();
            SessionActions.logout();
            //history.push("/");
          }
        });
      } else {
        localStorage.clear();
        SessionActions.logout();
        //history.push("/");
      }
    });
  }

  function validateForm() {
    formRef.current.checkInput();
    for (let i = 0; i < formRef.current.childs.length; i++) {
      const element = formRef.current.childs[i];
      element.validate(element.props.value);
    }
    formRef.current.isFormValid().then((response) => {
      setSnackbarMessage("Existen campos obligatorio sin completar");
      setAlertisFormValid(response);
      if (response) {
        switch (usuario.paso) {
          case "SELEC_PLAN":
            localStorage.clear();
            //solicita token  y redireccionar esta misma url con token
            SessionActions.generarToken("CONCERT").then((responseToken) => {
              //hacer login
              SessionActions.login(responseToken.data).then((response) => {
                validaCliente();
              });
            });
            break;
          case "VAL_EMAIL":
            //validar pin
            SengridActions.validarPin(usuario.token, usuario.pin).then(
              (response) => {
                if (response.data) {
                  //cambiar al siguiente paso
                  setusuario({
                    ...usuario,
                    paso: "DAT_FAC",
                  });
                  SessionActions.personaCertificados(
                    usuario.token,
                    usuario.rut,
                    usuario.email
                  ).then((response) => {
                    setdataTable(response.data);
                  });
                } else {
                  SengridActions.enviarPin(usuario.token, usuario.email).then(
                    (responsePin) => {
                      //informar al usuario que se ha enviado un nuevo pin
                      //setSignupModalPin({...signupModalPin,mensaje:'El código ingresado no es válido, pero no te preocupes, hemos enviado un nuevo código',modificarData:false})
                    }
                  );
                }
              }
            );
            break;
          case "DAT_FAC":
            //cargar tabla
            SessionActions.personaCertificados(
              usuario.token,
              usuario.rut,
              usuario.email
            ).then((response) => {
              setdataTable(response.data);
            });
            break;
        }
      }
    });
  }

  function validaCliente() {
    userToken = jwt(localStorage.getItem("currentUser").replace('"', "")); // decode your token here
    //crear llamada al back para validar al cliente con el rut y correo ingresado
    SessionActions.validarCliente(
      userToken.nameid,
      usuario.rut,
      usuario.email
    ).then((response) => {
      if (response.data.run !== "") {
        SengridActions.enviarPin(userToken.nameid, usuario.email).then(
          (responsePin) => {
            //informar que se ha enviado un pin al correo
            //si el cliente es valido entonces debe enviar el pin al correo ingresado y bloquear los campos
            setusuario({
              ...usuario,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              rut: response.data.run,
              email: response.data.email,
              token: userToken.nameid,
              paso: "VAL_EMAIL",
            });
          }
        );
      } else {
        //informar que el usuario no tiene registros como cliente en firma dox
      }
    });
  }

  function heightByOpened(open) {
    switch (open) {
      case 1:
        return "24rem";
      case 2:
        return "35rem";
      case 3:
        return "100%";
      case 4:
        return "60rem";

      default:
        return "33rem";
    }
  }

  return (
    <div>
      <Cabecera color="transparent" />
      {/* <Carrusel /> */}
      <div className={classes.section}>
        <div className={classes.container}>
          <Snackbar
            open={alertisFormValid ? false : true}
            onClose={(e) => setAlertisFormValid(true)}
            autoHideDuration={9000}
          >
            <Alert severity={severity}>{snackbarMessage}</Alert>
          </Snackbar>

          <GridContainer justify="center">
            <GridItem
              xs={12}
              sm={12}
              md={6}
              style={{ height: heightByOpened(open) }}
            >
              <NavPills
                alignCenter
                color="primary"
                setOpen={setOpen}
                tabs={[
                  {
                    tabButton: "Consulta Certificados",
                    tabIcon: VerifiedUserIcon,
                    tabContent: (
                      <CertificatesQueryForm
                        step={certQueryStep}
                        handleChangeStep={incrementCertQueryStep}
                      />
                    ),
                  },
                  {
                    tabButton: "CRL",
                    tabIcon: AccountBalanceIcon,
                    tabContent: (
                      <Card style={{ padding: "20px" }}>
                        <span>
                          <p>Firma Simple:</p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open("http://crl.firmadox.cl", "_blank")
                            }
                          >
                            <p>crl.firmadox.cl</p>
                          </Link>
                          <p>Firma Avanzada:</p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open("http://crl.firmadox.cl", "_blank")
                            }
                          >
                            <p>crl.firmadox.cl</p>
                          </Link>
                        </span>
                      </Card>
                    ),
                  },
                  {
                    tabButton: "Revocación de Certificados",
                    tabIcon: PersonAddDisabledIcon,
                    tabContent: (
                      <Card
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                      >
                        <CertificatesRevocationForm
                          setAlertisFormValid={setAlertisFormValid}
                          setSeverity={setSeverity}
                          setSnackbarMessage={setSnackbarMessage}
                        />
                      </Card>
                    ),
                  },
                  {
                    tabButton: "Descarga Cadena de Confianza",
                    tabIcon: CloudDownloadIcon,
                    tabContent: (
                      <Card style={{ padding: "20px" }}>
                        <span>
                          <p>
                            Firmadox, Acreditado según RAEX202200985, de 26 de
                            Mayo de 2022, de la Subsecretaría de Economía,
                            Fomento y Reconstrucción.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(window.CaRoot, "_blank")
                            }
                          >
                            <p>Descargar FirmaDox. : CaRoot</p>
                          </Link>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(window.CaIntermedia, "_blank")
                            }
                          >
                            <p>Descargar FirmaDox. : CaIntermedia</p>
                          </Link>
                          <br />
                          <br />
                          <p>Certificado Raiz, otras entidades Acreditadas:</p>
                          <br />
                          <p>Acepta.com</p>
                          <p>
                            Acreditado según R.A. Exenta N° 650, de 21 de
                            octubre de 2004, de la Subsecretaría de Economía,
                            Fomento y Reconstrucción.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_acepta.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Descargar</p>
                          </Link>
                          <br />
                          <p>E-Sign</p>
                          <p>
                            Acreditado según R.A. Exenta N° 330, de 1 de junio
                            de 2005, de la Subsecretaría de Economía, Fomento y
                            Reconstrucción.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_e_sign.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Descargar</p>
                          </Link>
                          <br />
                          <p>CertiNet</p>
                          <p>
                            Acreditado según R.A. Exenta N° 330, de 1 de junio
                            de 2005, de la Subsecretaría de Economía, Fomento y
                            Reconstrucción.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_certinet.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Descargar</p>
                          </Link>
                          <br />
                          <p>E-Partners</p>
                          <p>
                            Acreditado según R.A.E. Nº 172, de 30 de enero de
                            2013, de la Subsecretaría de Economía, y Empresas de
                            Menor Tamaño. Certificado Raíz E-Partners S.A.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_e_partners.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Certificado Raíz E-Partners S.A.</p>
                          </Link>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_e_partners.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Certificados Raíz al 08 de mayo de 2017.</p>
                          </Link>
                          <br />
                          <p>TOC</p>
                          <p>
                            Acreditado según R.A.E. Nº 1902, de 17 de junio de
                            2016, de la Subsecretaría de Economía y Empresas de
                            Menor Tamaño.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_toc.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Descargar</p>
                          </Link>
                          <br />
                          <p>IDok</p>
                          <p>
                            Acreditado según R.A.E. Nº 3396, de 06 de noviembre
                            de 2017, de la Subsecretaría de Economía y Empresas
                            de Menor Tamaño.
                          </p>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                            }}
                            onClick={(e) =>
                              window.open(
                                `${window.urlWebDefault}/Documentos/raiz_idok.rar`,
                                "_blank"
                              )
                            }
                          >
                            <p>Descargar</p>
                          </Link>
                        </span>
                      </Card>
                    ),
                  },
                  {
                    tabButton: "Manuales y Descargas",
                    tabIcon: DescriptionIcon,
                    tabContent: (
                      <Card style={{ padding: "20px" }}>
                        <span style={{ marginBottom: "10px" }}>
                          MANUALES FIRMA SIMPLE
                        </span>
                        <div
                          style={{
                            marginBottom: "20px",
                            paddingLeft: "10px",
                            display: "grid",
                          }}
                        >
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                              marginBottom: "10px",
                            }}
                            onClick={(e) =>
                              window.open(
                                "https://www.youtube.com/watch?v=LNlMh6Q8w3g",
                                "_blank"
                              )
                            }
                          >
                            Instalación de Certificados Firma Simple en PC
                          </Link>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                              marginBottom: "10px",
                            }}
                            onClick={(e) =>
                              window.open(
                                "https://www.youtube.com/watch?v=cYaXYXCP2bw",
                                "_blank"
                              )
                            }
                          >
                            Centralizar CertificadoFirma Simple en SII
                          </Link>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                              marginBottom: "10px",
                            }}
                            onClick={(e) =>
                              window.open(
                                "https://youtu.be/0VYAcL1G5Ys?si=qEhDe4ENIyFc75RI",
                                "_blank"
                              )
                            }
                          >
                            Descarga e instalación Certificado Raíz e Intermedio
                          </Link>
                        </div>
                        <span style={{ marginBottom: "10px" }}>
                          MANUALES FIRMA AVANZADA
                        </span>
                        <div
                          style={{
                            marginBottom: "20px",
                            paddingLeft: "10px",
                            display: "grid",
                          }}
                        >
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                              marginBottom: "10px",
                            }}
                            onClick={(e) =>
                              window.open(window.pdfInstallFEAWin, "_blank")
                            }
                          >
                            Instalación E-Token y Firma PDF - WINDOWS
                          </Link>
                          <Link
                            to="#"
                            state="uno"
                            style={{
                              color: "#a1c330",
                              textDecoration: "underline",
                              marginBottom: "10px",
                            }}
                            onClick={(e) =>
                              window.open(window.pdfInstallFEAMac, "_blank")
                            }
                          >
                            Instalación E-Token y Firma PDF - MAC
                          </Link>
                        </div>
                        <span style={{ marginBottom: "10px" }}>DESCARGAS</span>
                        <div style={{ paddingLeft: "10px", display: "grid" }}>
                          <span
                            style={{
                              marginBottom: "10px",
                            }}
                          >
                            Windows
                          </span>
                          <div
                            style={{
                              paddingLeft: "10px",
                              display: "grid",
                            }}
                          >
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drWinSaX32msi, "_blank")
                              }
                            >
                              MS Window 7 - 10 - 11 32 bits
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drWinSaX64msi, "_blank")
                              }
                            >
                              MS Window 7 - 10 - 11 64 Bits
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drWinGlX32msi, "_blank")
                              }
                            >
                              MS Windows XP - Vista - 32Bits
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drWinGlX64msi, "_blank")
                              }
                            >
                              MS Windows XP - Vista - 64Bits
                            </Link>
                          </div>

                          <span
                            style={{
                              marginBottom: "10px",
                            }}
                          >
                            MAC
                          </span>
                          <div
                            style={{
                              paddingLeft: "10px",
                              display: "grid",
                            }}
                          >
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacCatdmg, "_blank")
                              }
                            >
                              Catalina
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacMavdmg, "_blank")
                              }
                            >
                              Mavericks Yosemite el_capitan sierra
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacMojdmg, "_blank")
                              }
                            >
                              Mojave
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacMondmg, "_blank")
                              }
                            >
                              Monterrey
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacVendmg, "_blank")
                              }
                            >
                              Ventura
                            </Link>
                            <Link
                              to="#"
                              state="uno"
                              style={{
                                color: "#a1c330",
                                textDecoration: "underline",
                                marginBottom: "10px",
                              }}
                              onClick={(e) =>
                                window.open(window.drMacSondmg, "_blank")
                              }
                            >
                              Sonoma
                            </Link>
                          </div>
                        </div>
                      </Card>
                    ),
                  },
                  {
                    tabButton: "Descargar Firma Simple",
                    tabIcon: AssignmentIcon,
                    onClick: () => history.push("/descargar-simple"),
                  },
                ]}
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <PiePagina />
    </div>
  );
}
